import { render, staticRenderFns } from "./EquipmentTransferStatusBadge.vue?vue&type=template&id=50cd6a72"
import script from "./EquipmentTransferStatusBadge.vue?vue&type=script&lang=js"
export * from "./EquipmentTransferStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports